<template>
    <div>
      <div class="row justify-content-between align-items-center">
        <div class="col-md-4 customHeading">
          <h3>{{moduleName}}</h3>
        </div>

        <div class = "col-md-3 green-text">
          <b>Remaining Stock in Sacks & KGs: &nbsp;&nbsp;{{mainStock != null ? mainStock.totalNoOfSacks:0}}&nbsp; & &nbsp;{{mainStock != null ? mainStock.totalWeightInKgs:0}}</b>
      
        </div>
      </div>
      <div class="row">
        <div class="col">
        <hr color="#CACACA" style="border-top: 2px solid rgb(202, 202, 202); margin-top: 5px;">
        </div>
      </div>
      <div>
        <div class="row">
          <div class="col">
            <form ref="MoveToSiloForm" @submit.stop.prevent= "handleSubmit" style="margin-top:4%">
              <div class="row">
              
                  <!--NAME INPUT-->
                  <div class="col-md-4"></div>
                  <div class="col-md-4 shadow-custom">
                    <b-form-group  label="No Of Sacks" label-for="NoOfSacks" autocomplete="off">
                      <b-form-input id="NoOfSacks" v-model= "NoOfSacks" type = "number" required></b-form-input>
                    </b-form-group>
                    <b-form-group  label="Total Weight" label-for="Total Weight" autocomplete="off">
                      <b-form-input id="TotalWeight" v-model= "TotalWeight" type = "number" required></b-form-input>
                    </b-form-group>
                     <button type="button" style="width:106px;background-color:#5bb8cd;color:white" class="btn" @click ="moveToSilo()">Submit</button>
                  </div>
                  <div class="col-md-4"></div>
              </div>
                  
            </form>
          </div>
      </div>

      

    
    <Spinner v-if="isLoading" message="Loading..." size="medium" 
      line-fg-color="rgb(222 224 219" 
      line-bg-color="rgb(68 66 62)">
    </Spinner>
    <!--/SPINNER-->	
      </div>
        <Toaster ref ="toaster"/>
   </div>
</template>

<script>
import axios from 'axios';
// import config from '../config.js';
import Spinner from 'vue-simple-spinner'
import Toaster from '../toaster';
export default {
    name: 'MoveToSilo',
    data(){
        return{
          moduleName:'Move To Silo',
          Id:null,
          isLoading:false,
          NoOfSacks:null,
          TotalWeight:0,
          mainStock:null,
		}
  },
 created()
 {
   this.getMainStock();
 },
methods:
{
  getMainStock()
    {
      this.isLoading = true;
      axios.post('/silo/getall',{"UserId":this.$auth.user().id,"CompanyId":this.$auth.user().companyId,
      "PageSize":this.perPage,"Page":this.page})
      .then(res=>
      {
        this.isLoading = false;
        if(res.data.status ==1)
        {
          // console.log(res.data)
          // this.wheatIssues=res.data.data.records;
          this.mainStock = res.data.data.mainStock;
        }
        else if (res.data.status == 0)
        {
          this.mainStock = res.data.data.mainStock;
        }
        else if(res.data.status == -1)
        {
            this.$refs.toaster.showToast('Error','danger',res.data.msg)
        }
      });
    },
   moveToSilo(){ 
     if(this.NoOfSacks == null ||this.NoOfSacks <=0)
     {
       this.$refs.toaster.showToast('Error','danger','Please enter a valid no of sacks')
       return;
     }
     if(this.TotalWeight <=0)
     {
       this.$refs.toaster.showToast('Error','danger','Please enter a valid weight')
       return;
     }
     axios.post('/silo/MoveToSilo',
      {"NoOfSacks":parseFloat(this.NoOfSacks),"IssuedWeight":Number(this.TotalWeight),
      "CompanyId":this.$auth.user().companyId,"UserId":this.$auth.user().id
      
      })
      .then(res=>{
        // console.log(res)
            if(res.data.status == 1)
            {
                  // this.$bvModal.hide('MoveToSiloModal')
                  this.$refs.toaster.showToast('Sucess','success','Moved to silo successfully')
                  this.getMainStock();
                  this.resetModal();                 
            }
             else if(res.data.status == -1)
            {
               
                 this.$refs.toaster.showToast('Error','danger',res.data.msg);
            }
        })
        .catch((err) => {
      console.warn('error during http call', err);
     })
    },

   checkFormValidity() {
        const valid = this.$refs.MoveToSiloForm.checkValidity()
        // this.usernameState = valid
        return valid
      },
      resetModal() {
     
        this.TotalWeight = 0;
        this.DateIssued = null;
        this.NoOfSacks = null; 
       
      },
      handleOk(bvModalEvt) {
        // Prevent modal from closing
        bvModalEvt.preventDefault()
        // Trigger submit handler
        this.handleSubmit()
      },
      handleSubmit() {
        // Exit when the form isn't valid
        if (!this.checkFormValidity()) {
          return
        } 
        this.moveToSilo()
      }
       
  },
  
  components:{
    Spinner,
    Toaster
  },
  
}
</script>

<style scoped>
button.page-link {
	display: inline-block;
}
button.page-link {
    font-size: 20px;
    color: #29b3ed;
    font-weight: 500;
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
select#class-dropdown{
    width: 80%;
    margin-left: 16%
}
.row{
  margin-left:0px;
  margin-right:0px;
}
.col{
  padding-left:0px;
  padding-right:0px;
}
</style>